import { useRef } from "react"
import Marquee from "../marquee/marquee"
import isClientSide from "@utils/is-client-side"

const DevHubPromo = ({ recipes }) => {
  const scrollingContent = useRef()
  const countPerLane = 10
  const recipeLanes = [
    recipes.splice(0, countPerLane),
    recipes.splice(0, countPerLane),
    recipes.splice(0, countPerLane),
  ]

  const animationSpeeds = [0.35, 0.43, 0.5]

  return (
    <div className="scrollingContent" ref={scrollingContent}>
      {isClientSide() &&
        recipeLanes.map((recipes, i) => {
          return <Marquee root={scrollingContent} speed={animationSpeeds[i]} content={recipes} key={`lane-${i}`} />
        })}
    </div>
  )
}

export default DevHubPromo
